import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import { Form } from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const ContainerInfo = (props, {
  handleChange,
  selectedBookingNO,
  selectedBookingItem,
  bookingNo, bLNumber,
  // onhandle_Con20FT, 
  // onhandle_Con40FT, 
  // onhandle_Con20RF, 
  // onhandle_Con40RF, 
  onhandleCon_NumList }) => {
  const [containerSizeList, setContainerSizeList] = useState(undefined);
  const [baseUrl, setBaseUrl] = useState('http://mol.evolve-demo.com/api/');
  const [pageComponent, setPageComponent] = useState('bookingcosting');
  const [inputFields, setInputFields] = useState([{ name: 'indexis0', }])
  const [indexCount, setIndexCount] = useState(0);
  const [containerItem, setContainerItem] = useState(undefined);
  const [con_Size, setCon_Size] = useState({});
  const [con_NumList, setCon_NumList] = useState([]);
  const [conTag, setConTag] = useState('');
  const [conSize, setConSize] = useState('');
  const [_Con20FT, set_Con20FT] = useState('');
  const [_Con40FT, set_Con40FT] = useState('');
  const [_Con20RF, set_Con20RF] = useState('');
  const [_Con40RF, set_Con40RF] = useState('');

  const setSelectedBooking = (selectedBookingNO) => {

    if (selectedBookingNO) {
      console.log('selected booking id is ' + bookingNo);

      const currunt_ID = selectedBookingNO;
      fetch(`${baseUrl}${pageComponent}/show/${currunt_ID}`)
        .then(response => response.json())
        .then(data => {
          console.log(data.booking);
          // setBLNumber(data.booking[0].BLNo);
        })
        .catch(error => {
          alert(error());
        })
    }




  }

  useEffect(() => {
    const stringArray = props.valueToConNUMList;
  }, [])


  useEffect(() => {

  }, [])


  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/getcontainers`)
      .then(response => response.json())
      .then(data => {
        setContainerSizeList(data.container);
      })
      .catch(error => {
        alert(error());
      })
  }, [])



  const conArrySet = (key, value) => {

    containerSizeList.forEach(con_size => {
      let key_val = key;
      let con_value = value;
      if (con_size.ContDesc === key_val) {
        if (key_val == '20ft') {
          set_Con20FT(con_value);
          // onhandle_Con20FT(_Con20FT)
        }
        if (key_val == '40ft') {
          set_Con40FT(con_value);
          // onhandle_Con40FT(_Con40FT)
        }
        if (key_val == '20rf') {
          set_Con20RF(con_value);
          // onhandle_Con20RF(_Con20RF)
        }
        if (key_val == '40rf') {
          set_Con40RF(con_value);
          // onhandle_Con40RF(_Con40RF);
        }

        const newKeyValuePair = {
          ...con_Size,
          [key_val]: con_value,
        };

        setCon_Size(newKeyValuePair);
        onhandleCon_NumList(con_NumList);
      } else {

      }

    });
  }


  //   const handleContainer = () => {


  //     const inputData = {_20ft: _Con20FT, _40ft: _Con40FT, _20rf: _Con20RF, _40rf: _Con40RF, BLNo: bLNumber, BookingNo : bookingNo };
  //         axios.post(`${baseUrl}${pageComponent}/containerstore`, inputData)
  //             .then(response => {
  //                 console.log(response.data);
  //                 window.location.reload(false);
  //                 alert('Successfully Save Data');
  //             })
  //             .catch(error => {
  //                 console.error(error);
  //                 alert(error);
  //             });

  //             const inputNOSData = {ContainerNO :con_NumList, BLNo: bLNumber, BookingNo : bookingNo  };
  //             axios.post(`${baseUrl}${pageComponent}/nosstore`, inputNOSData)
  //                 .then(response => {
  //                     console.log(response.data);
  //                     window.location.reload(false);
  //                     alert('Successfully Save Data');
  //                 })
  //                 .catch(error => {
  //                     console.error(error);
  //                     alert(error);
  //                 });
  // };



  const handleFormChange =  (index, event, value) => {

    const appendValue = async (value) => {
      setCon_NumList([...con_NumList, value]);
      props.handleChangeConNUMList([...con_NumList, value]);
      console.log(props.valueToConNUMList);
    };
    
    appendValue(value);

    if (indexCount == index && event.target.value !== '') {
      let newfield = { name: `indexis${index}`, }
      setInputFields([...inputFields, newfield])
      setIndexCount(indexCount + 1);
    }

   


  }

  // function setSelectedBooking(selectedBookingNO){
  //  console.log('selected booking id is ' + selectedBookingNO);

  //  const currunt_ID = 14;
  //     fetch(`${baseUrl}${pageComponent}/show/${currunt_ID}`)
  //         .then(response => response.json())
  //         .then(data => {
  //             console.log(data.booking);
  //             // setBLNumber(data.booking[0].BLNo);
  //         })
  //         .catch(error => {
  //             alert(error());
  //         })
  // }

  const valueToCon20FTHadle = (event) => {
    props.handleChangeCon20FT(event.target.value);
    set_Con20FT(event.target.value);
  };

  const valueToCon40FTHadle = (event) => {
    props.handleChangeCon40FT(event.target.value);
    set_Con40FT(event.target.value);
  };

  const valueToCon20RFHadle = (event) => {
    props.handleChangeCon20RF(event.target.value);
    set_Con20RF(event.target.value);
  };

  const valueToCon40RFHadle = (event) => {
    props.handleChangeCon40RF(event.target.value);
    set_Con40RF(event.target.value);
  };

  return (
    <div className="d-flex flex-column ">

      {/* {con_NumList.map((number, index) => (
        <p key={index}>{number}</p>
      ))} */}



      
      {/* <h1>{selectedBookingNO}</h1> */}
      {/* <input type="text" value={selectedBookingNO} onChange={setSelectedBooking(selectedBookingNO)} /> */}
      <Form.Label>Container Size & Vol {props.valueToCost}</Form.Label>
      <Row>


        <>
          {containerSizeList !== undefined ? containerSizeList.map((containerItem, id) => {
            if (containerItem.ContDesc === '20ft') {
              return (
                <Col className="ps-3 pe-3" sm={3} key={id}>
                  <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                    <Form.Label column> {containerItem.ContDesc} {props.valueToCon20FT}</Form.Label>
                    <Form.Control column sm={10} type="text" value={props.valueToCon20FT} placeholder="Enter value of container" name={containerItem.ContDesc} onChange={valueToCon20FTHadle} />
                  </Form.Group>
                </Col>
              );
            }

            if (containerItem.ContDesc === '40ft') {
              return (
                <Col className="ps-3 pe-3" sm={3} key={id}>
                  <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                    <Form.Label column> {containerItem.ContDesc} {props.valueToCon40FT}</Form.Label>
                    <Form.Control column sm={10} type="text" value={props.valueToCon40FT} placeholder="Enter value of container" name={containerItem.ContDesc} onChange={valueToCon40FTHadle} />
                  </Form.Group>
                </Col>
              );
            }

            if (containerItem.ContDesc === '20rf') {
              return (
                <Col className="ps-3 pe-3" sm={3} key={id}>
                  <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                    <Form.Label column> {containerItem.ContDesc} {props.valueToCon20RF}</Form.Label>
                    <Form.Control column sm={10} type="text" value={props.valueToCon20RF} placeholder="Enter value of container" name={containerItem.ContDesc} onChange={valueToCon20RFHadle} />
                  </Form.Group>
                </Col>
              );
            }

            if (containerItem.ContDesc === '40rf') {
              return (
                <Col className="ps-3 pe-3" sm={3} key={id}>
                  <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                    <Form.Label column> {containerItem.ContDesc}</Form.Label>
                    <Form.Control column sm={10} type="text" value={props.valueToCon40RF} placeholder="Enter value of container" name={containerItem.ContDesc} onChange={valueToCon40RFHadle} />
                  </Form.Group>
                </Col>
              );
            }


            else {
              return (
                <Col className="ps-3 pe-3" sm={3} key={id}>
                  <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                    <Form.Label column> {containerItem.ContDesc}</Form.Label>
                    <Form.Control column sm={10} type="text" placeholder="Enter value of container" name={containerItem.ContDesc} onBlur={(e => conArrySet(containerItem.ContDesc, e.target.value))} />
                  </Form.Group>
                </Col>
              );
            }
          }) : ''}



          {/* <Col className="ps-3 pe-3" sm={3} key={id}>
              <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                <Form.Label column> {containerItem.ContDesc}</Form.Label>
                <Form.Control column sm={10} type="text" placeholder="Enter value of container" name={containerItem.ContDesc} onBlur={(e => conArrySet(containerItem.ContDesc, e.target.value))} />
              </Form.Group>
            </Col> */}

        </>






      </Row>

      <Row>
        <Col>
          <Form.Label>Container Numbers</Form.Label>
          {inputFields !== undefined ? inputFields.map((input, index) => (
            <div key={index}>
              <Form.Control
                className="mb-1 w-25"
                type="text"
                name={input.name}
                placeholder='Container Number'
                onBlur={event => handleFormChange(index, event, event.target.value)}
              />
            </div>

          )) : ''

          }
          {/* <button className="button" onClick={handleContainer}>show containers</button> */}
        </Col>
      </Row>
    </div>
  );
}

export default ContainerInfo;